import {Action} from '@ngrx/store';
import {ArrayResponse, type} from '../../shared';
import {PlayerFilter, SelectedPlayers} from '../models/player-filter';
import {Player} from '../../shared/models/player';

export const playerListActionTypes = {
  TOGGLE_SEARCH: type('[players] Toggle Search Form'),
  QUICK_SEARCH: type('[players] Quick Search'),
  SEARCH: type('[players] Search'),
  CHANGE_PAGE_SIZE: type('[players] Change Page Size'),
  PAGE_TO: type('[players] Page To'),
  ORDER_BY: type('[players] Order By'),
  LOAD: type('[players] Load'),
  LOAD_BY_SITES: type('[players By site] Load'),
  LOAD_BY_SUBSCRIPTION: type('[players By subscription] Load'),
  LOAD_SUCCESS: type('[players] Load Success'),
  LOAD_FAIL: type('[players] Load Fail'),
  SELECT_PAGE: type('[players] Select Page'),
  UNSELECT_PAGE: type('[players] Unselect Page'),
  TOGGLE_SELECTION: type('[players] Toggle Selection'),
  TOGGLE_SELECTION_TAGS: type('[players] Toggle Selection Tags'),
  CLEAR: type('[players] Clear Data')
};


export class ToggleSearchPlayersAction implements Action {
  readonly type = playerListActionTypes.TOGGLE_SEARCH;
  constructor(public payload?: boolean) {}
}

export class QuickSearchPlayersAction implements Action {
  readonly type = playerListActionTypes.QUICK_SEARCH;
  constructor(public payload?: string) {}
}

export class SearchPlayersAction implements Action {
  readonly type = playerListActionTypes.SEARCH;
  constructor(public payload?: PlayerFilter) {}
}

export class ChangePlayersPageSizeAction implements Action {
  readonly type = playerListActionTypes.CHANGE_PAGE_SIZE;
  constructor(public payload?: number) {}
}

export class PagePlayersToAction implements Action {
  readonly type = playerListActionTypes.PAGE_TO;
  constructor(public payload?: number) {}
}

export class OrderPlayersByAction implements Action {
  readonly type = playerListActionTypes.ORDER_BY;
  constructor(public payload?: string) {}
}

export class LoadPlayersAction implements Action {
  readonly type = playerListActionTypes.LOAD;
  constructor() {}
}
export class LoadPlayersBySiteAction implements Action {
  readonly type = playerListActionTypes.LOAD_BY_SITES;
  constructor() {
    // console.log('LoadPlayersBySiteAction')
  }
}
export class LoadPlayerBySubscriptionBySiteAction implements Action {
  readonly type = playerListActionTypes.LOAD_BY_SUBSCRIPTION;
  constructor() {
    // console.log('LoadPlayersBySiteAction')
  }
}
export class LoadPlayersSuccessAction implements Action {
  readonly type = playerListActionTypes.LOAD_SUCCESS;
  constructor(public payload?: ArrayResponse<Player>) {}
}

export class LoadPlayersFailAction implements Action {
  readonly type = playerListActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
export class SelectPlayersPageAction implements Action {
  readonly type = playerListActionTypes.SELECT_PAGE;
  constructor() {}
}

export class UnselectPlayersPageAction implements Action {
  readonly type = playerListActionTypes.UNSELECT_PAGE;
  constructor() {}
}
export class TogglePlayersSelectionAction implements Action {
  readonly type = playerListActionTypes.TOGGLE_SELECTION;
  constructor(public payload?: SelectedPlayers) {}
}
export class ClearPlayersAction implements Action {
  readonly type = playerListActionTypes.CLEAR;
  constructor() {}
}
